import React, { useState } from 'react';
import './UXMetricCard.css';
import { getScoreColorClass } from 'utils/scoreColors';
import { useTranslation } from 'react-i18next';
import ScoreInfoButton from '../../ScoreInfoButton/ScoreInfoButton';
const UXMetricCard = ({
  title,
  score,
  infoTooltip = 'Information sur cette métrique',
  initialExpanded = false,
  children,
}) => {
  const [expanded, setExpanded] = useState(initialExpanded);
  const { t } = useTranslation();
  // Toggle expanded state
  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={`ux-metric-card ${expanded ? 'expanded' : 'collapsed'}`}>
      {/* Header - Always visible */}
      <div className="ux-metric-header" onClick={toggleExpanded}>
        <div className="ux-metric-title">
          {title}
          <ScoreInfoButton
            text={t(infoTooltip)}
            onClick={(e) => e.stopPropagation()}
          />
        </div>

        <div className="ux-metric-score-container">
          <div className={`ux-metric-score ${getScoreColorClass(score)}`}>
            {score | 0}%
          </div>

          <button
            className="toggle-button"
            onClick={(e) => {
              e.stopPropagation(); // Not needed since parent has same handler, but good practice
              toggleExpanded();
            }}
            aria-label={expanded ? 'Collapse' : 'Expand'}
          >
            {expanded ? '−' : '+'}
          </button>
        </div>
      </div>

      {/* Content - Only visible when expanded */}
      {expanded && (
        <div className="ux-metric-content">
          <hr className="ux-metric-divider" />
          {children}
        </div>
      )}
    </div>
  );
};

export default UXMetricCard;
